import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

// Колонка справа от меню: страница и подвал. Сама не `main` — его ставит страница.
export const SidebarInset = ({ className, ...props }: ComponentProps<"div">) => (
  <div
    data-slot="sidebar-inset"
    className={cn("flex min-w-0 flex-1 flex-col", className)}
    {...props}
  />
);
